<template>
  <el-dialog
    title="新增费用"
    :visible="templeShowDialog"
    width="80%"
    center
    @open="handleOpen"
    @close="closeDialog"
    append-to-body
  >
    <SiruiSearch
      ref="baseInfoFormRef"
      :query="baseFormData"
      :label-width="'130px'"
      :columns="formColumn"
      :rules="formRules"
      :isQueryPanel="false"
    >
    </SiruiSearch>
    <div class="collapse-content">
      <vxe-toolbar>
        <template v-slot:buttons>
          <vxe-button type="primary" class="vxe-btn-primary" @click="insertEvent">
            新增
          </vxe-button>
          <vxe-button
            type="primary"
            class="vxe-btn-delete"
            @click="handleDelete()"
            :style="'background-color:' + '#FE8783' + ';border:1px solid ' + '#FE8783'"
          >
            删除
          </vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-table
        width="100%"
        align="left"
        class="vxe-table-element"
        :auto-resize="true"
        border
        resizable
        show-overflow
        :data="expensesTableData"
        :edit-config="{ trigger: 'click', mode: 'cell', activeMethod: activeRowMethod }"
        size="mini"
        ref="expensesTable"
        :max-height="'500px'"
        :edit-rules="tableRules"
      >
        <vxe-table-column type="checkbox" width="60"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumn"
          :key="index"
          :type="item.type"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <template v-if="item.field == 'expenseType'">
              {{ expenseType.find((item) => item.value == row['expenseType'])?.label }}
            </template>
            <template v-else>
              {{ row[item.field] }}
            </template>
          </template>
          <template v-slot:edit="{ row }">
            <el-select
              v-if="item.field == 'expenseType'"
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(i, index) in expenseType"
                :key="index"
                :label="i.label"
                :value="i.value"
              >
              </el-option>
            </el-select>
            <el-date-picker
              v-if="item.field == 'accountPeriod'"
              v-model="row[item.field]"
              @change="handleChange(row, item.field)"
              type="month"
              placeholder="请选择日期"
            >
            </el-date-picker>
            <el-date-picker
              v-if="item.field == 'periodDateFrom'"
              v-model="row[item.field]"
              @change="handleChange(row, item.field)"
              type="date"
              placeholder="请选择"
            >
            </el-date-picker>
            <el-date-picker
              v-if="item.field == 'periodDateUntil'"
              v-model="row[item.field]"
              :picker-options="pickerTimeOptions"
              @change="handleChange(row, item.field)"
              @focus="() => handleFocusDate(row)"
              type="date"
              placeholder="请选择"
            >
            </el-date-picker>
            <!-- 结算单价 -->
            <el-input-number
              :precision="4"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'originalPrice'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 结算数量 -->
            <el-input-number
              :precision="6"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'statementQuantity'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 原币结算金额 -->
            <el-input-number
              :precision="2"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'originalAmount'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 本币结算金额（含税） -->
            <el-input-number
              :precision="2"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'domesticAmount'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 备注 -->
            <el-input
              v-if="item.editRender.name == 'remark'"
              v-model="row[item.field]"
              maxlength="50"
              @input="() => handleChange(row, item.field)"
            ></el-input>
            <el-select
              v-if="item.field == 'energyCode'"
              v-model="row[item.field]"
              @change="(e) => handleChange(row, item.field)"
            >
              <el-option
                v-for="(i, index) in energyList"
                :key="index"
                :label="i.energyCode"
                :value="i.energyId"
              >
              </el-option>
            </el-select>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="closeDialog" plain>取消</el-button>
      <el-button type="primary" @click="confirm" :loading="load">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import moment from 'moment';
  import { generateExpenses } from '@/api/receivablesAndPayables/model';
  import parkPropertyApi from '@/api/receivablesAndPayables/parkProperty.js';
  export default {
    name: 'GenerateExpensesDialog',
    props: {
      showDialog: {
        type: Boolean,
        default: false,
      },
      form: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      formColumn() {
        return [
          {
            name: '业务类别',
            prop: 'businessCategory',
            type: 'select',
            options: this.dictListMap?.businessCategory || [],
            disabled: true,
          },
          {
            name: '合同编号：',
            prop: 'contractNo',
            type: 'searchTableSpec',
            searchType: 'propertyLeaseContract',
            extraData: {
              contractCompanyNo: this.baseFormData.businessCompanyNo,
              contractDepartmentNo: this.baseFormData.businessDepartmentCode,
              auditStatus: '03',
              // contractStatus: '02',
            },
            isMultiple: true,
            changeMethod: this.changeContractMethod,
            currentValue: this.baseFormData?.contractNo,
          },
          {
            name: '客户名称：',
            prop: 'customerNo',
            type: 'input',
            disabled: true,
          },
          {
            prop: 'spaceId',
            name: '空间资产：',
            type: 'select',
            placeholder: '空间资产',
            value: 'spaceId',
            label: 'leaseSpaceName',
            options: this.spaceList,
            changeMethod: this.changeSpaceId,
          },
        ];
      },
      tableColumn() {
        return [
          {
            field: 'expenseType',
            title: '费用类型',
            width: '120',
            editRender: {
              name: 'expenseTypeName',
              options: this.expenseTypeList,
            },
          },
          {
            field: 'accountPeriod',
            title: '应收账期',
            width: '240',
            editRender: {
              name: 'accountPeriod',
            },
          },
          {
            field: 'periodDateFrom',
            title: '业务结算日期从',
            width: '240',
            editRender: {
              name: 'periodDateFrom',
            },
          },
          {
            field: 'periodDateUntil',
            title: '业务结算日期至',
            width: '240',
            editRender: {
              name: 'periodDateUntil',
            },
          },
          {
            field: 'originalPrice',
            title: '结算单价(含税)',
            width: '150',
            editRender: { name: 'originalPrice' },
          },
          {
            field: 'statementQuantity',
            title: '结算数量',
            width: '150',
            editRender: {
              name: 'statementQuantity',
            },
          },
          // {
          //   field: 'unitName',
          //   title: '计量单位',
          //   width: '140',
          //   editRender: {
          //     name: 'unitName',
          //   },
          // },
          {
            field: 'originalAmount',
            title: '原币结算金额(含税)',
            width: '150',
            editRender: {
              name: 'originalAmount',
            },
          },
          {
            field: 'currencyName',
            title: '币种',
            width: '140',
            editRender: { name: 'currencyName' },
          },
          {
            field: 'exchangeRate',
            title: '汇率',
            width: '140',
            editRender: { name: 'exchangeRate' },
          },
          {
            field: 'domesticAmount',
            title: '本币结算金额（含税）',
            width: '170',
            editRender: { name: 'domesticAmount' },
          },
          {
            field: 'remark',
            title: '备注',
            width: '140',
            editRender: { name: 'remark' },
          },
        ];
      },
      expenseType() {
        return this.dictListMap?.property_settlement_cost;
      },
    },
    watch: {
      showDialog(var1, var2) {
        this.templeShowDialog = var2;
        this.templeShowDialog = var1;
      },
    },
    data() {
      return {
        pickerTimeOptions: {},
        baseFormData: JSON.parse(JSON.stringify(generateExpenses)),
        load: false,
        chargeMethod: '', //合同计费方式
        columnListDefault: [],
        templeShowDialog: this.showDialog,
        expensesTableData: [],
        spaceList: [], //空间列表
        energyList: [], //
        expenseTypeList: [],
        isGetDepartment: true,
        formRules: {
          contractNo: [{ required: true, message: '请选择合同编号', trigger: 'change' }],
          customerNo: [{ required: true, message: '请选择客户名称', trigger: 'change' }],
          businessCategory: [{ required: true, message: '业务类别', trigger: 'blur' }],
          spaceId: [{ required: true, message: '请选择空间', trigger: 'change' }],
          // settlementNoLike: [{ required: true, message: '请选择空间资产', trigger: 'blur' }],

          // energyId: [
          //   { required: true, message: '请选择能耗表', trigger: 'blur' },
          //   { validator: this.checkEneryCode, trigger: '' },
          // ],
        },
        tableRules: {
          expenseType: [{ required: true, message: '请选择费用类型', trigger: 'blur' }],
          accountPeriod: [{ required: true, message: '请选择应付账期', trigger: 'blur' }],
          periodDateFrom: [{ required: true, message: '请选择结算日期', trigger: 'blur' }],
          periodDateUntil: [{ required: true, message: '请选择结算日期', trigger: 'blur' }],
          originalPrice: [{ required: true, message: '请选择结算单价', trigger: 'blur' }],
          statementQuantity: [{ required: true, message: '请选择结算数量', trigger: 'blur' }],
          originalAmount: [{ required: true, message: '请设置原币结算金额', trigger: 'blur' }],
          domesticAmount: [
            { required: true, message: '请设置本币结算金额（含税）', trigger: 'blur' },
          ],
        },
      };
    },
    mounted() {},
    methods: {
      // 结束日期验证
      handleFocusDate(row) {
        this.pickerTimeOptions = {
          disabledDate: (time) => {
            let endTime = moment(time).format('YYYY-MM');
            let startTime = moment(row['periodDateFrom']).format('YYYY-MM');
            return endTime < startTime;
          },
        };
      },
      activeRowMethod({ columnIndex, row }) {
        console.log(columnIndex, row);
        console.log('tis.spaceList', this.spaceList);
        if (columnIndex == 10 || columnIndex == 9) {
          return false;
        }
        return true;
      },
      // 改变表格值
      handleChange(row, field) {
        console.log(row, field);
        if (field == 'accountPeriod') {
          row['accountPeriod'] = moment(row['accountPeriod']).format('YYYY-MM');
        } else if (field == 'periodDateFrom') {
          row['periodDateFrom'] = moment(row['periodDateFrom']).format('YYYY-MM-DD');
        } else if (field == 'periodDateUntil') {
          row['periodDateUntil'] = moment(row['periodDateUntil']).format('YYYY-MM-DD');
        } else if (field == 'originalPrice') {
          if (row['statementQuantity'] != null && row['statementQuantity'] != '') {
            row['originalAmount'] = +(row['originalPrice'] * row['statementQuantity']).toFixed(2);
            row['domesticAmount'] = +(row['originalPrice'] * row['statementQuantity']).toFixed(2);
          }
        } else if (field == 'statementQuantity') {
          if (row['originalPrice'] != null && row['originalPrice'] != '') {
            row['originalAmount'] = +(row['originalPrice'] * row['statementQuantity']).toFixed(2);
            row['domesticAmount'] = +(row['originalPrice'] * row['statementQuantity']).toFixed(2);
          }
        } else if (field == 'expenseType') {
          // row['expenseType'] = row['expenseTypeName'];
          row['expenseTypeName'] = this.expenseType?.find(
            (item) => item.value == row['expenseType']
          )?.label;
        }
      },
      // 新增
      insertEvent() {
        this.$refs['baseInfoFormRef'].validate((valid) => {
          if (valid) {
            let record = {
              rowId: parseInt(new Date().getTime() / 1000) + '',
              businessCompanyNo: this.baseFormData.businessCompanyNo,
              businessDepartmentCode: this.baseFormData.businessDepartmentCode,
              businessCompanyName: this.userInfo.companyName,
              businessDepartmentName: this.userInfo.departmentName,
              salesmanName: this.userInfo.personName,
              salesmanNo: this.userInfo.personNo,
              businessCategory: this.baseFormData.businessCategory,
              contractNo: this.baseFormData.contractNo,
              contractId: this.baseFormData.contractId,
              customerName: this.baseFormData.customerNo,
              spaceAssetId: this.baseFormData.spaceId,
              spaceAssetName: this.baseFormData.spaceName,
              createMethod: '02',
              expenseTypeName: '其他',
              expenseType: '99',
              accountPeriod: '',
              periodDateFrom: '',
              periodDateUntil: '',
              originalPrice: '',
              statementQuantity: '',
              unitName: '',
              originalAmount: '',
              currencyCode: 'CNY',
              currencyName: '中国人民币（国际）',
              exchangeRate: '1',
              domesticAmount: '',
              remark: '',
            };
            this.$refs.expensesTable
              .insert(record, -1)
              .then(({ row }) => this.$refs.expensesTable.setActiveRow(row));
          }
        });
      },
      // 删除行
      handleDelete() {
        const selectedList = this.$refs.expensesTable.getSelectRecords(); // 选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: '请选择数据！',
            type: 'error',
          });
          return;
        }
        this.$refs.expensesTable.removeSelecteds();
        this.$message({
          showClose: true,
          type: 'success',
          message: '删除成功！',
        });
        // this.$confirmAction()
        //   .then(() => {
        //     // vxe-table中删除方法
        //     this.$refs.expensesTable.removeSelecteds();
        //     this.$message({
        //       showClose: true,
        //       type: 'success',
        //       message: '删除成功！',
        //     });
        //   })
        //   .catch((e) => {
        //     console.log(e);
        //     this.$message({
        //       showClose: true,
        //       type: 'info',
        //       message: '删除失败',
        //     });
        //   });
      },
      getTableData() {
        const $table = this.$refs.expensesTable;
        return $table.getTableData().fullData;
      },
      // 修改合同
      changeContractMethod(val) {
        this.baseFormData.contractNo = val[0].contractNo;
        this.baseFormData.contractId = val[0].id;
        this.baseFormData.customerNo = val[0].customerName;
        this.expensesTableData = [];
        this.getAllSpaceInfoByContract();
        if (val[0].contractCategory == '02') {
          this.formRules.spaceId = [];
          this.$refs.baseInfoFormRef?.$refs.queryFrom.clearValidate();
        } else {
          this.formRules.spaceId = [{ required: true, message: '请选择空间', trigger: 'change' }];
        }
      },
      changeSpaceId(val) {
        console.log(val, '修改片区');
        let spaceInfo = this.spaceList.filter((item) => item.spaceId == val);
        this.baseFormData.spaceName = spaceInfo[0].leaseSpaceName;
      },
      async getAllSpaceInfoByContract() {
        const { data } = await this.$axios.post(
          `${parkPropertyApi.GET_ALL_SPACEINFO}?ids=${this.baseFormData.contractId}`
        );
        if (data.code == 0) {
          this.spaceList = data.data;
          this.spaceList.forEach((item) => (item.spaceId = item.spaceId.toString()));
        } else {
          this.spaceList = [];
        }
      },
      // 初始化数据
      handleOpen() {
        this.baseFormData = JSON.parse(JSON.stringify(generateExpenses));
        this.baseFormData.businessCategory = this.form.businessCategory;
        this.baseFormData.businessCompanyNo = this.form.businessCompanyNo;
        this.baseFormData.businessDepartmentCode = this.form.businessDepartmentCode;
        this.$refs.baseInfoFormRef?.$refs.queryFrom.resetFields();
        this.expenseTypeList = this.$baseRequest
          .getDictListMapByType('property_settlement_cost')
          .filter((item) => item.value != '100');
      },
      // 关闭弹窗
      closeDialog() {
        console.log('this.$refs.baseInfoFormRef', this.$refs.baseInfoFormRef);
        this.$refs.baseInfoFormRef?.$refs.queryFrom.clearValidate();
        this.formRules.spaceId = [{ required: true, message: '请选择空间', trigger: 'change' }];
        this.expensesTableData = [];
        this.$emit('closeDialog', false);
        this.load = false;
      },
      async confirm() {
        const $table = this.$refs.expensesTable;
        const errMap = await $table.validate().catch((errMap) => errMap);
        let fullExpensesTableData = this.getTableData();
        if (fullExpensesTableData.length == 0) {
          return this.$message.warning('请添加数据！');
        }
        if (errMap) {
          this.$message.error('请完善数据!');
        } else {
          const { data } = await this.$axios.post(
            parkPropertyApi.RECEIVABLESEXPENSE_SAVE,
            fullExpensesTableData
          );
          if (data.code == 0) {
            this.$message.success('新增费用成功！');
            this.$emit('save');
          } else {
            if (data.msg != '') {
              return this.$message.error(data.msg);
            }
            this.$message.error('新增费用失败！');
          }
          this.$emit('closeDialog', false);
          this.load = false;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .global-messageZindex {
    z-index: 3000 !important;
  }
</style>
